var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "9px",
    viewBox: "0 0 14 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow_cancel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instruction",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mass-payouts_Instruction-new",
    transform: "translate(-38.000000, -850.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instruction_3",
    transform: "translate(36.000000, 844.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4676332,6.31188727 L15.7028907,9.50622904 C16.1240669,9.92207874 16.1240669,10.5954472 15.7028907,11.0112969 L12.4676332,14.2056387 C12.2573571,14.4138716 11.9815647,14.517988 11.7051483,14.517988 C11.4287319,14.517988 11.1535634,14.4138716 10.9426633,14.2056387 C10.5214871,13.789789 10.5214871,13.1164205 10.9426633,12.7005708 L12.347208,11.3107087 L3.07821115,11.3113248 C2.48232478,11.3113248 2,10.8344838 2,10.2467495 C2,9.65778315 2.48232478,9.18155824 3.07821115,9.18155824 L12.3253693,9.18155824 L10.9432873,7.81757122 C10.522111,7.40110545 10.522111,6.72773697 10.9432873,6.31188727 C11.3644635,5.89603758 12.047081,5.89603758 12.4682572,6.31188727 L12.4676332,6.31188727 Z",
    id: "icon/arrow_cancel"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.e0437b092cafd4872d6cfcf594b893c1.svg";
export { ForwardRef as ReactComponent };